import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import { connect } from "react-redux";
import axios from "axios";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";
// service
import { getParticipants } from "../../../utils/services/participants";
import { updateVehicle } from "../../../utils/services/vehicles";
import { getTotalVehicle } from "../../../utils/services/transfer";
import { getGroups } from "../../../utils/services/group";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// telefone
import { PhoneInput } from "react-international-phone";
import { paisesPt } from "../../../utils/helpers/data/countries";

const listTypeVehicles = [
  { label: "Carro", value: "Carro" },
  { label: "Ônibus", value: "Ônibus" },
  { label: "Van", value: "Van" },
];

function ModalEditVehicle(props) {
  const { isOpen, toggle, data } = props;
  const [isLoading, setIsloading] = useState(false);
  //  lista de participantes
  const [allParticipants, setAllParticipants] = useState([]);
  //confirmação
  const [success_dlg, setsuccess_dlg] = useState(false);
  // erro
  const [erroForm, setErroForm] = useState({});
  // lista de opções de local
  const [localizationOptionsOrigin, setLocalizationOptionsOrigin] = useState(
    [],
  );
  const [localizationOptionsDestination, setLocalizationOptionsDestination] =
    useState([]);
  // exibir as opções de localizações
  const [googleOptions, setGoogleOptions] = useState(true);
  // form
  const [transferType, setTransferType] = useState(data?.transferType);
  const [description, setDescription] = useState(data.description);
  const [origin, setOrigin] = useState(data.origin);
  const [destination, setDestination] = useState(data.destination);
  const [editLatLonOrigem, setEditLatLonOrigem] = useState(false);
  const [editLatLonDestino, setEditLatLonDestino] = useState(false);
  const [departureLongitude, setDepartureLongitude] = useState(
    data.departureLongitude,
  );
  const [departureLatitude, setDepartureLatitude] = useState(
    data.departureLatitude,
  );
  const [arrivalLongitude, setArrivalLongitude] = useState(
    data.arrivalLongitude,
  );
  const [arrivalLatitude, setArrivalLatitude] = useState(data.arrivalLatitude);
  const [departureDatetime, setDepartureDatetime] = useState(
    data.departureDatetime.split("T")[0],
  );
  const [arrivalDatetime, setArrivalDatetime] = useState(
    data.arrivalDatetime?.split("T")[0],
  );
  const [departureTime, setDepartureTime] = useState(
    data.departureDatetime.split("T")[1].substring(0, 5),
  );
  const [arrivalTime, setArrivalTime] = useState(
    data.arrivalDatetime?.split("T")[1].substring(0, 5),
  );
  const [driverName, setDriverName] = useState(data.driverName);
  const [coordinatorName, setCoordinatorName] = useState(
    data.coordinatorName ? data.coordinatorName : "",
  );
  const [coordinatorPhone, setCoordinatorPhone] = useState(
    data.coordinatorPhone ? data.coordinatorPhone : "",
  );
  const [vehicleType, setVehicleType] = useState(data.vehicleType);
  const [seatingCapacity, setSeatingCapacity] = useState(data.seatingCapacity);
  const [company, setCompany] = useState(data.company);
  const [meetingPoint, setMeetingPoint] = useState(data.meetingPoint);
  const [phone, setPhone] = useState(data.phone);
  const [notes, setNotes] = useState(data.notes);
  const [totalVehicles, setTotalVehicle] = useState();
  const [participantsSelecteds, setParticipantsSelecteds] = useState(
    data?.participants?.map((e) => {
      return {
        label: e.name,
        value: e.loginId,
      };
    }),
  );
  // desabilitar campos quando o status for cancelado ou finalizados e ficar apenas leitura
  const [isDisabled, setIsDisabled] = useState(false);
  //state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  const [groupsMulti, setGroupsMulti] = useState(
    data?.grupos?.map((e) => {
      return {
        label: e.name,
        value: e.id,
      };
    }),
  );

  async function getTotalVehicleInTransfer() {
    const res = await getTotalVehicle(data.id, props.idEvent);
    setTotalVehicle(res.data.vehicles.total);
  }

  function checkDateTimeInterval() {
    const isValidDate = (d) => d && d !== "";
    const isValidTime = (t) => t && t !== "";

    const hasStartDate = isValidDate(departureDatetime);
    const hasEndDate = isValidDate(arrivalDatetime);
    const hasStartHour = isValidTime(departureTime);
    const hasEndHour = isValidTime(arrivalTime);

    const startDateTime =
      hasStartDate && hasStartHour
        ? new Date(`${departureDatetime}T${departureTime}`)
        : null;

    const endDateTime =
      hasEndDate && hasEndHour
        ? new Date(`${arrivalDatetime}T${arrivalTime}`)
        : null;

    if (
      startDateTime &&
      hasEndDate &&
      !hasEndHour &&
      departureDatetime > arrivalDatetime
    ) {
      return false;
    }

    if (startDateTime && (!hasEndDate || !hasEndHour)) {
      return true;
    }

    if (
      (startDateTime && endDateTime && endDateTime >= startDateTime) ||
      (startDateTime && !endDateTime && !arrivalTime)
    ) {
      return true;
    }

    return false;
  }

  function getAllParticipants() {
    getParticipants({
      idEvent: props.idEvent,
      offset: 1,
      limit: 10000,
      search: "",
      columnSearch: "login",
      status: "ATIVO",
    }).then((res) => {
      if (res.message === "users") {
        setAllParticipants(res.data.data);
      }
    });
    // .catch((error) => console.log("erro", error));
  }

  function getLocalizations(e, setState) {
    axios
      .get(
        `https://us-central1-inteegra-ping.cloudfunctions.net/GoogleAutoComplete?search=${e}&language=pt`,
      )
      .then((localizations) => {
        if (localizations?.data?.success?.status === "OK")
          setState(localizations.data.success.predictions);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  function verifyErros() {
    if (!transferType) {
      setErroForm({ transferType: "O campo Tipo de transfe é obrigatório" });
      return;
    } else setErroForm({});

    if (!description) {
      setErroForm({ name: "O campo Nome é obrigatório" });
      return;
    } else setErroForm({});

    if (!origin) {
      setErroForm({ origin: "O campo Origem é obrigatório" });
      return;
    } else setErroForm({});

    if (!destination) {
      setErroForm({ destination: "O campo Destino é obrigatório" });
      return;
    } else setErroForm({});

    if (!departureDatetime) {
      setErroForm({ departureDatetime: "O campo Data da Saída é obrigatório" });
      return;
    } else setErroForm({});

    if (!departureTime) {
      setErroForm({ departureTime: "O campo Hora da Saída é obrigatório" });
      return;
    } else setErroForm({});

    if (!arrivalDatetime && arrivalTime) {
      setErroForm({
        arrivalDatetime:
          "Com a inclusão da Hora da chegada o campo Data da Chegada é obrigatório",
      });
      return;
    } else setErroForm({});

    if (arrivalDatetime && !arrivalTime) {
      setErroForm({
        arrivalTime:
          "Com a inclusão da Data da Chegada o campo Hora da chegada é obrigatório",
      });
      return;
    } else setErroForm({});

    if (departureDatetime && departureTime && !arrivalDatetime && arrivalTime) {
      setErroForm({ arrivalDatetime: "A Data da Chegada deve ser informada." });
      return;
    } else setErroForm({});

    if (!checkDateTimeInterval()) {
      setErroForm({
        arrivalDatetime:
          "A Data e Hora da Chegada não pode ser menor que a Data e Hora da Saída.",
      });
      return;
    } else setErroForm({});

    if (!seatingCapacity || seatingCapacity < 1) {
      setErroForm({
        seatingCapacity: "O campo Capacidade do veículo é obrigatório",
      });
      return;
    } else setErroForm({});

    if (seatingCapacity < totalVehicles) {
      setErroForm({
        seatingCapacity:
          "A capacidade não pode ser menor que a quantidade de participantes no Veículo.",
      });
      return;
    } else setErroForm({});

    if (seatingCapacity < participantsSelecteds?.length) {
      setErroForm({
        seatingCapacity:
          "A Capacidade do veículo deve ser maior que a quantidade de participantes",
      });
      return;
    } else setErroForm({});

    if (phone.slice(0, 3) === "+55") {
      const onlyNumbers = phone.replace(/\D+/g, "");
      if (onlyNumbers.length > 2 && onlyNumbers.length < 12) {
        setErroForm({
          phone:
            "O campo Telefone para o Brasil precisa ter no mínimo 8 caracteres.",
        });
        return;
      } else setErroForm({});
    } else setErroForm({});

    if (coordinatorPhone.slice(0, 3) === "+55") {
      const onlyNumbers = coordinatorPhone.replace(/\D+/g, "");
      if (onlyNumbers.length > 2 && onlyNumbers.length < 12) {
        setErroForm({
          coordinatorPhone:
            "O campo Telefone para o Brasil precisa ter no mínimo 8 caracteres.",
        });
        return;
      } else setErroForm({});
    } else setErroForm({});

    submitForm();
  }

  function submitForm() {
    var dataForm = {
      eventId: props.idEvent,
      transferType: transferType,
      description,
      origin: origin,
      destination: destination,
      departureLongitude: parseFloat(departureLongitude) ?? null,
      departureLatitude: parseFloat(departureLatitude) ?? null,
      arrivalLongitude: parseFloat(arrivalLongitude) ?? null,
      arrivalLatitude: parseFloat(arrivalLatitude) ?? null,
      departureDatetime:
        departureDatetime && departureTime
          ? `${departureDatetime}T${departureTime}`
          : null,
      arrivalDatetime:
        arrivalDatetime && arrivalTime
          ? `${arrivalDatetime}T${arrivalTime}`
          : null,
      driverName,
      coordinatorName,
      coordinatorPhone,
      vehicleType,
      seatingCapacity: parseInt(seatingCapacity),
      company,
      meetingPoint,
      phone,
      notes,
      participants: participantsSelecteds.map((e) => {
        return e.value;
      }),
      grupos:
        groupsMulti.length > 0 && groupsMulti[0].value === "todos"
          ? groups.map((e) => {
              return e.id;
            })
          : groupsMulti.map((e) => {
              return e.value;
            }),
    };

    setIsloading(true);
    updateVehicle(dataForm, data.id)
      .then((res) => {
        setIsloading(false);
        // console.log(res.message);
        if (res.message === "updated") {
          setsuccess_dlg(true);
          setIsloading(false);
        }
      })
      .catch((error) => {
        setIsloading(false);
        // console.log("erro", error);
      });
  }

  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  async function getGroupsFunc() {
    await getGroups({
      jwt: "",
      eventId: props.idEvent,
      offset: 1,
      limit: 0,
      search: "",
    })
      .then((response) => {
        setGroups(response.findOneGroupData.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  useEffect(() => {
    getTotalVehicleInTransfer();
    getAllParticipants();
    getGroupsFunc();

    if ((data && data.status === "Cancelado") || data.status === "Finalizado")
      setIsDisabled(true);
  }, []);

  return (
    <>
      {" "}
      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggleBackdrop();
        }}
        autoFocus={true}
        centered={true}
        size="lg"
      >
        {success_dlg ? (
          <SweetAlert
            success
            title={"Editado"}
            onConfirm={() => {
              setsuccess_dlg(false);
              toggle();
              setTimeout(() => {
                props.getAllVehicles();
              }, 1000);
            }}
          >
            {"Veículo editado com sucesso!"}
          </SweetAlert>
        ) : null}
        <ModalHeader toggle={toggle}>Editar Veículo</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label">ID</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={data.id}
                  disabled={true}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Tipo de transfer *</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setTransferType(
                      e.target.value.toUpperCase().replace(" ", ""),
                    )
                  }
                  value={transferType}
                  disabled={isDisabled}
                />
                {erroForm.transferType && (
                  <a style={{ color: "red" }}>{erroForm.transferType}</a>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Nome *</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={data.description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={isDisabled}
                />
                {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div className="form-check form-switch">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`checkGoogle`}
                  checked={googleOptions}
                  disabled={isDisabled}
                  onChange={(e) => {
                    setGoogleOptions(e.target.checked);
                  }}
                />
                <label className="form-check-label" htmlFor={`checkGoogle`}>
                  Usar serviços de localização da Google
                </label>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Origem *</label>
                <input
                  value={origin}
                  className="form-control"
                  type="text"
                  id="localInputOrigem"
                  disabled={isDisabled}
                  onChange={(e) => {
                    setOrigin(e.target.value);
                    setDepartureLatitude("");
                    setDepartureLongitude("");
                    if (googleOptions)
                      getLocalizations(
                        e.target.value,
                        setLocalizationOptionsOrigin,
                      );
                  }}
                />
                {erroForm.origin && (
                  <p style={{ color: "red" }}>{erroForm.origin}</p>
                )}
              </div>

              {googleOptions &&
                origin &&
                localizationOptionsOrigin &&
                localizationOptionsOrigin.length > 0 && (
                  <ul className="localization">
                    {localizationOptionsOrigin.map((l) => {
                      return (
                        <li
                          key={l.description}
                          className="localizationLi"
                          onClick={() =>
                            setOrigin(l.description) >
                            setLocalizationOptionsOrigin([])
                          }
                        >
                          {l.description}
                        </li>
                      );
                    })}
                  </ul>
                )}
            </Col>

            <Col md={12}>
              <div
                className="form-check form-switch"
                style={{
                  borderTop: "1px solid #dbdbdb",
                  borderBottom: "1px solid #dbdbdb",
                  marginTop: 5,
                  marginBottom: 5,
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`checkLatLonOrigem`}
                  disabled={isDisabled}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setEditLatLonOrigem(true);
                    } else setEditLatLonOrigem(false);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={`checkLatLonOrigem`}
                >
                  Editar Latitude/Longitude de Origem
                </label>
              </div>
            </Col>
          </Row>
          {editLatLonOrigem && (
            <Row>
              <Col md={6}>
                <div>
                  <label className="form-label">Latitude de origem </label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={data.departureLatitude}
                    value={departureLatitude}
                    onChange={(e) => setDepartureLatitude(e.target.value)}
                    disabled={isDisabled}
                  />
                  {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.origin}</p>
                )} */}
                </div>
              </Col>
              <Col md={6}>
                <div>
                  <label className="form-label">Longitude de origem</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={data.departureLongitude}
                    value={departureLongitude}
                    onChange={(e) => setDepartureLongitude(e.target.value)}
                    disabled={isDisabled}
                  />
                  {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )} */}
                </div>
              </Col>{" "}
            </Row>
          )}
          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Destino *</label>
                <input
                  className="form-control"
                  type="text"
                  value={destination}
                  id="localInputDestino"
                  disabled={isDisabled}
                  onChange={(e) => {
                    setDestination(e.target.value);
                    setArrivalLatitude("");
                    setArrivalLongitude("");
                    if (googleOptions)
                      getLocalizations(
                        e.target.value,
                        setLocalizationOptionsDestination,
                      );
                  }}
                />
                {erroForm.destination && (
                  <p style={{ color: "red" }}>{erroForm.destination}</p>
                )}
              </div>

              {googleOptions &&
                destination &&
                localizationOptionsDestination &&
                localizationOptionsDestination.length > 0 && (
                  <ul className="localization">
                    {localizationOptionsDestination.map((l) => {
                      return (
                        <li
                          key={l.description}
                          className="localizationLi"
                          onClick={() =>
                            setDestination(l.description) >
                            setLocalizationOptionsDestination([])
                          }
                        >
                          {l.description}
                        </li>
                      );
                    })}
                  </ul>
                )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div
                className="form-check form-switch"
                style={{
                  borderTop: "1px solid #dbdbdb",
                  borderBottom: "1px solid #dbdbdb",
                  marginTop: 5,
                  marginBottom: 5,
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`checkLatLonDestino`}
                  disabled={isDisabled}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setEditLatLonDestino(true);
                    } else setEditLatLonDestino(false);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={`checkLatLonDestino`}
                >
                  Editar Latitude/Longitude de Destino
                </label>
              </div>
            </Col>
          </Row>
          {editLatLonDestino && (
            <Row style={{ marginTop: "10px" }}>
              <Col md={6}>
                <div>
                  <label className="form-label">Latitude de destino </label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={data.arrivalLatitude}
                    value={arrivalLatitude}
                    onChange={(e) => setArrivalLatitude(e.target.value)}
                    disabled={isDisabled}
                  />
                  {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.origin}</p>
                )} */}
                </div>
              </Col>
              <Col md={6}>
                <div>
                  <label className="form-label">Longitude de destino</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={data.arrivalLongitude}
                    value={arrivalLongitude}
                    onChange={(e) => setArrivalLongitude(e.target.value)}
                    disabled={isDisabled}
                  />
                  {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )} */}
                </div>
              </Col>
            </Row>
          )}
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Data da Saída *</label>
                <input
                  className="form-control"
                  onChange={(e) => setDepartureDatetime(e.target.value)}
                  defaultValue={data.departureDatetime.split("T")[0]}
                  type="date"
                  id="example-datetime-local-input"
                  disabled={isDisabled}
                />
                {erroForm.departureDatetime && (
                  <p style={{ color: "red" }}>{erroForm.departureDatetime}</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Hora da saída *</label>
                <input
                  className="form-control"
                  type="time"
                  id="example-datetime-local-input"
                  defaultValue={departureTime}
                  onChange={(e) => setDepartureTime(e.target.value)}
                  disabled={isDisabled}
                />
                {erroForm.departureTime && (
                  <p style={{ color: "red" }}>{erroForm.departureTime}</p>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Data da Chegada </label>
                <input
                  className="form-control"
                  onChange={(e) => setArrivalDatetime(e.target.value)}
                  disabled={isDisabled}
                  defaultValue={
                    arrivalDatetime?.includes("1969") ? "" : arrivalDatetime
                  }
                  type="date"
                  id="example-datetime-local-input"
                  min={departureDatetime}
                />
                {erroForm.arrivalDatetime && (
                  <p style={{ color: "red" }}>{erroForm.arrivalDatetime}</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Hora da chegada</label>
                <input
                  className="form-control"
                  disabled={isDisabled}
                  type="time"
                  id="example-datetime-local-input"
                  defaultValue={
                    arrivalDatetime?.includes("1969") ? "" : arrivalTime
                  }
                  onChange={(e) => setArrivalTime(e.target.value)}
                />
                {erroForm.arrivalTime && (
                  <p style={{ color: "red" }}>{erroForm.arrivalTime}</p>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Capacidade do veículo *</label>
                <input
                  className="form-control"
                  type="number"
                  disabled={isDisabled}
                  defaultValue={data.seatingCapacity}
                  onChange={(e) => setSeatingCapacity(e.target.value)}
                />
                {erroForm.seatingCapacity && (
                  <p style={{ color: "red" }}>{erroForm.seatingCapacity}</p>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Participantes no Veículo</label>
                <input
                  className="form-control"
                  type="text"
                  value={totalVehicles}
                  disabled
                />
              </div>
              {erroForm.outOfStock && (
                <p style={{ color: "red" }}>{erroForm.outOfStock}</p>
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            {/* <Col md={12}>
              <div>
                <label className="form-label">Tipo de veículo</label>
                <input
                  className="form-control"
                  disabled={isDisabled}
                  type="text"
                  defaultValue={data.vehicleType}
                  onChange={(e) => setVehicleType(e.target.value)}
                />
              </div>
            </Col> */}
            <Col lg={12}>
              <label className="form-label">Tipo de veículo</label>
              <Select
                placeholder={"Selecione um tipo de veículo..."}
                isClearable={true}
                defaultValue={
                  vehicleType ? { label: vehicleType, value: vehicleType } : {}
                }
                onChange={(e, actionMeta) => {
                  if (actionMeta.action === "clear") {
                    setVehicleType("");
                  } else {
                    setVehicleType(e.value);
                  }
                }}
                options={[
                  {
                    options: [
                      ...listTypeVehicles?.map((e) => {
                        return { label: e.label, value: e.value };
                      }),
                    ],
                  },
                ]}
                classNamePrefix="select2-selection"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                    overflowY: "auto",
                  }),
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Empresa</label>
                <input
                  className="form-control"
                  type="text"
                  disabled={isDisabled}
                  defaultValue={data.company}
                  onChange={(e) => setCompany(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Nome do motorista</label>
                <input
                  className="form-control"
                  disabled={isDisabled}
                  type="text"
                  defaultValue={data.driverName}
                  onChange={(e) => setDriverName(e.target.value)}
                />
                {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )} */}
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Telefone do motorista</label>
                <PhoneInput
                  defaultCountry="br"
                  value={phone || ""}
                  onChange={(phone) => setPhone(phone)}
                  countries={paisesPt}
                  inputStyle={{ width: "100%" }}
                  isDisabled={isDisabled}
                />
                {erroForm.phone && (
                  <a style={{ color: "red" }}>{erroForm.phone}</a>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col md={6}>
              <div>
                <label className="form-label">Nome do coordenador</label>
                <input
                  className="form-control"
                  type="text"
                  value={coordinatorName}
                  onChange={(e) => setCoordinatorName(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label className="form-label">Telefone do coordenador</label>
                <PhoneInput
                  defaultCountry="br"
                  value={coordinatorPhone || ""}
                  onChange={(phone) => setCoordinatorPhone(phone)}
                  countries={paisesPt}
                  inputStyle={{ width: "100%" }}
                  isDisabled={isDisabled}
                />
                {erroForm.coordinatorPhone && (
                  <a style={{ color: "red" }}>{erroForm.coordinatorPhone}</a>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Ponto de encontro</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={data.meetingPoint}
                  onChange={(e) => setMeetingPoint(e.target.value)}
                  disabled={isDisabled}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "10px" }}>
            <Col md={12}>
              <div>
                <label className="form-label">Observações</label>
                <input
                  className="form-control"
                  disabled={isDisabled}
                  type="text"
                  defaultValue={data.notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
                {/* {erroForm.name && (
                  <p style={{ color: "red" }}>{erroForm.name}</p>
                )} */}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Participantes</label>
                <Select
                  placeholder={"Selecione"}
                  isMulti={true}
                  isDisabled={isDisabled}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  onChange={(e) => {
                    setParticipantsSelecteds(e);
                  }}
                  value={participantsSelecteds}
                  options={[
                    {
                      options: allParticipants.map((e) => ({
                        label: e.nome,
                        value: e.id,
                      })),
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  placeholder={"Selecione"}
                  isMulti={true}
                  value={groupsMulti}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  onChange={(e) => handleGroupMulti(e)}
                  options={[
                    {
                      options:
                        groups?.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1rem",
              }}
            >
              <Button
                color="danger"
                style={{ width: 80 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>

              <ButtonSpinner
                isLoading={isLoading}
                isDisabled={isDisabled}
                title={"Salvar"}
                onClick={verifyErros}
                action="U"
                marginLeft={10}
              />
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalEditVehicle);
